module.exports = __webpack_public_path__ + "static/media/yellow-right-star-icon.581a9e34.png";